<base-support-modal [title]="title" [btnOkClass]="'btn-danger'" [btnOkLabel]="'Разблокировать'" (onOk)="ok()" >
	<p>Возобновить работу пользователя: <strong>{{email}}</strong>?</p>
	<br>
	<p>Пользователь получит письмо о разблокировке на email: <strong>{{email}}</strong></p>
</base-support-modal>
